var modules_6cfce947 = {"container":"_1jmq4gm","checked":"_bofowm","control":"_105w3oc","disabled":"_1y2ni61","read-only":"_e3toz6","input":"_1t4at7l","label":"_1jxcau9","icon":"_yzvmpr"};
import "../../../assets/G51zS1mW.css";

export { modules_6cfce947 as default };
//# sourceMappingURL=Checkbox.module.less.js.map
